import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export function useNorthStarVisitor() {
  const { pathname } = useLocation();
  const { isAdmin, loading, adminChecked, user } = useAuth();
  useEffect(() => {
    if (loading || (user && !adminChecked) || isAdmin || pathname.startsWith('/admin')) return;
    if (navigator.webdriver || navigator.doNotTrack === '1' || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl) return;
    let visitorId: string;
    try {
      if (localStorage.getItem('r0hub:statistics-opt-out') === 'true') return;
      visitorId = localStorage.getItem('r0hub:visitor-id') || crypto.randomUUID();
      localStorage.setItem('r0hub:visitor-id', visitorId);
    } catch { return; }
    let sessionId: string;
    try {
      sessionId = sessionStorage.getItem('r0hub:visit-session') || crypto.randomUUID();
      sessionStorage.setItem('r0hub:visit-session', sessionId);
    } catch { return; }
    let lastInteraction = Date.now();
    const interaction = (event: Event) => { if (event.isTrusted) lastInteraction = Date.now(); };
    const send = () => {
      if (document.hidden || Date.now() - lastInteraction > 60_000) return;
      try { if (localStorage.getItem('r0hub:statistics-opt-out') === 'true') return; } catch { return; }
      void supabase.functions.invoke('track-north-star-visit', {
        body: { visitor_id: visitorId, session_id: sessionId, path: pathname },
      }).catch(() => {});
    };
    const visibility = () => {
      sessionId = crypto.randomUUID();
      try { sessionStorage.setItem('r0hub:visit-session', sessionId); } catch { /* unavailable */ }
      lastInteraction = Date.now();
      if (!document.hidden) send();
    };
    send();
    const interval = window.setInterval(send, 10_000);
    const events = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, interaction, { passive: true }));
    document.addEventListener('visibilitychange', visibility);
    return () => {
      clearInterval(interval);
      events.forEach(event => window.removeEventListener(event, interaction));
      document.removeEventListener('visibilitychange', visibility);
    };
  }, [pathname, loading, adminChecked, isAdmin, user?.id]);
}